import { render, staticRenderFns } from "./ActivityInboxButton.vue?vue&type=template&id=a78e7082"
import script from "./ActivityInboxButton.vue?vue&type=script&lang=ts"
export * from "./ActivityInboxButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports